import React, { memo, useEffect, useState } from "react";
import { MDBIcon, MDBBtn, MDBSpinner, MDBLoadingManagement } from "mdb-react-ui-kit";
import {
  getAutoAttendant,
  getSpecificAAGroup,
} from "../../apiclients/streamsapi_bridge";
import { getAudioFile, getAudioFileForTTS, getAudioFileNew } from "../mediaplayers/AudioPlayer";
import { Handle } from "@xyflow/react";
import DropDown from "./DropDown";
export default memo(({ data, isConnectable }) => {
  const [handles, setHandles] = useState(
    data.handles || [{ id: "0", lable: "0", name: "0", default: true }]
  );
  let optionsArray = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "*",
    "#"

  ];
  const [selectBoxes, setSelectBoxes] = useState([]);
  const availableOptions = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "*",
    "#",
  ];
  const [selectValues, setSelectValues] = useState({
    select0: "",
    select1: "",
    select2: "",
    select3: "",
    select4: "",
    select5: "",
    select6: "",
    select7: "",
    select8: "",
    select9: "",
    selectstar: "",
    selecthash: "",
  });

  const [selected, setSelected] = useState(
    data.selected_object ? data.selected_object.label : ""
  );
  const [isloading, setIsloading] = useState(false);
  const [aagroups, setAagroups] = useState([]);
  const [optionerror, setOptionerror] = useState([]);
  const [playerPath, setPlayerPath] = useState("");
  const [customData, setCustomData] = useState(aagroups);
  const [greetingsInfo, setGreetingsInfo] = useState({});
  const basicRef = React.useRef(null);
  const [showLoader, setshowLoader] = useState(false);

  async function fetchAAgroupsData() {
    setIsloading(true);
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getAutoAttendant(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid
    );
    const rawData = await response.json();
    if (response.status === 200) {
      if (rawData.message === "No Record Found") {
        setAagroups([{ _id: -1, title: "Create New" }]);
      } else {
        try {
          setAagroups([{ _id: -1, title: "Create New" }, ...rawData.groups]);
        } catch (e) {
          setAagroups([{ _id: -1, title: "Create New" }]);
          console.log(e);
        }
      }
    }
    setTimeout(() => {
      data.actionExecutor({
        action: 0,
      });
    }, 1000);

    setIsloading(false);
  }

  const handleAddSelectBox = (updatedSelectBoxes) => {
    const remainingOptions = availableOptions.filter(
      (option) => !updatedSelectBoxes.includes(option)
    );
    if (remainingOptions.length > 0) {
      setSelectBoxes([...updatedSelectBoxes, remainingOptions[0]]);
      return remainingOptions[0];
    } else {
      alert("All options have been used");
    }
  };
  const handleChange = (e, handleId) => {
    const value = e.target.value;

    const isDuplicate = data.handles.some(
      (h) => h.id !== handleId && h.label === value
    );

    if (isDuplicate) {
      alert("This value is already selected in another select box.");
      return;
    }

    const updatedHandles = data.handles.map((h) =>
      h.id === handleId
        ? { ...h, label: value, value: value, id: value, name: value }
        : h
    );

    setHandles(updatedHandles);
    data.handles = updatedHandles;
    data.actionExecutor({ action: 4, handles: updatedHandles }); // ← Changed to action 4
  };

  const onHandleUpdate = (handles) => {
    data.handles = handles;
  };
  function onDelete(id) {
    data.onDelete(id);
  }
  const deleteHandle = (handles) => {
    data.handles = handles;
  };
  function updateHandle(newValue, key) {
    console.log(data.handles);
    let isExists = data.handles.filter(
      (item) => item.value * 1 === newValue * 1
    );
    console.log(isExists);
    if (isExists.length > 0) {
      let trr = new Array();
      trr[key] = "Value is in use";
      setOptionerror(trr);
      data.actionExecutor({ action: 6 });
      return;
    }
    setOptionerror([]);
    console.log(newValue);
    console.log(key);
    let obj = JSON.parse(JSON.stringify(data.handles[key + 1]));
    if (obj) {
      obj.value = newValue;
      data.handles[key + 1] = obj;
    }
  }

  const delteHandle = (id) => {
    console.log(id);

    if (data.handles.length <= 2) {
      alert(
        "You cannot delete this option. Please add another option first, then try removing it."
      );
      return;
    }
    let updatedData = data.handles.filter((item) => item.id + "" !== id + "");
    console.log(updatedData);
    data.handles = [...updatedData];
    let handles = data.handles;
    setHandles(handles);
    data.actionExecutor({ action: 15, value: id });
  };

  const addOptions = () => {
    if (data.handles && data.handles.length >= 13) {
      return;
    }
    let handles = data.handles;
    let updatedSelectBoxes = [];
    if (data.handles) {
      const initialValues = data.handles.map((item) => item.label + "");
      updatedSelectBoxes = [...initialValues];
      setSelectBoxes(updatedSelectBoxes);
    }
    let handleId = handleAddSelectBox(updatedSelectBoxes);

    console.log("Handl.... " + handleId);

    const updatedData = data.handles.map((item) => {
      if (!item.hasOwnProperty("list")) {
        return {
          ...item, // Spread existing properties
          list: updatedSelectBoxes, // Add the new attribute
        };
      }
      // If the attribute exists, return the item unchanged
      return item;
    });
    data.handles = [
      ...updatedData,
      {
        id: handleId,
        value: handleId,
        isselect: true,
        class: "handletextSelect",
        top: 210 + handles.length * 30,
        label: handleId,
        list: updatedSelectBoxes,
      },
    ];
    setHandles(handles);
    data.actionExecutor({ action: 2, value: handles });
  };

  useEffect(() => {
    fetchAAgroupsData();
    if (data.selected_object) {
      fetchAAGroupData(data.selected_object, 1);
    }
    if (!data.handles) {
      data.handles = [
        { id: "minus1", label: "Timeout", name: "Timeout" },
        { id: "0", label: "0", name: "0", default: true },
      ];
    }
  }, []);
  const addItem = (newItem) => {
    if (newItem && newItem.isnew === 1) {
      if (!aagroups.some((item) => item.title === newItem.label)) {
        console.log(newItem);
        console.log("includijng Item");
        if (newItem && newItem.label != "Create New") {
          if (newItem.label) newItem.title = newItem.label;
          setSelected(newItem.label);
          setAagroups([...aagroups.slice(0, 1), newItem, ...aagroups.slice(1)]);
        }
      }
    }
  };
  useEffect(() => {
    if (data.selected_object) addItem(data.selected_object);
  }, [data.selected_object]);

  const windowsMap = {};

  const openLocation = (e) => {
    if (localStorage.getItem("s_message")) {
      console.log("Removing s_message...");
      localStorage.removeItem("s_message");
    } else {
      console.log("s_message does not exist in localStorage.");
    }

    e.preventDefault();
    e.stopPropagation();

    localStorage.setItem(
      "selectedItem",
      data.selected_object ? data.selected_object.code : -1
    );

    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const width = screenWidth * 0.8;
    const height = screenHeight * 0.8;
    const left = (screenWidth - width) / 2;
    const top = (screenHeight - height) / 2;

    const windowFeatures = `width=${width},height=${height},top=${top},left=${left}`;

    localStorage.setItem(
      "AAGrpInfo",
      JSON.stringify({
        code: data.selected_object.code,
        title: data.selected_object.title
      })
    );

    const windowName = `callflowAANode`;

    if (windowsMap[windowName] && !windowsMap[windowName].closed) {
      // Focus and reload the existing window
      windowsMap[windowName].focus();
      windowsMap[windowName].location.reload();
    } else {
      // Open new window and store its reference
      const accWindow = window.open("/accinfo", "", windowFeatures);
      windowsMap[windowName] = accWindow;

      window.receiveMessageFromAAChild = (nodeFlag) => {
        if (nodeFlag === 1) {
          data.actionExecutor({ action: 17, value: "Auto-Attendent" });
          console.log("Received message from child:", nodeFlag);
        }
      };
    }
  };


  async function fetchAAGroupData(tGrp, tfirstload) {
    const response = await getSpecificAAGroup(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      tGrp.code
    );
    const rawData = await response.json();
    if (!rawData) {
      window.alert(`info with id  not found`);
    }
    console.log(rawData);
    data.info = rawData.greetings;
    data.greetinfo = rawData.greetings;
    setGreetingsInfo(rawData.greetings);
    requestAudioFile(rawData.greetings ? rawData.greetings.pre_announce : null);

    if (!tfirstload) {
      data.actionExecutor({
        action: 7,
        value: tGrp || -1,
        greetingsData: rawData.greetings,
      });
      if (data.handles) {
        const initialValues = data.handles.map((item) => item.id);
        const updatedSelectBoxes = [...initialValues];
        setSelectBoxes(updatedSelectBoxes);
      }
    } else {
      data.actionExecutor({
        action: 0,
        value: tGrp || -1,
      });
      // data.actionExecutor({
      //   action: 3,
      //   value: data.handles,
      // });
    }
  }

  async function streamResponseToPlayer(apiResponse, onDone) {
    try {
      const reader = apiResponse.body.getReader();
      const chunks = [];
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        if (value) chunks.push(value);
      }
      if (onDone) onDone(chunks);
      // Detect actual format from magic bytes so the blob has the correct MIME type.
      // A wrong MIME type causes the browser to fire an error on preload="metadata",
      // which shows "--:--" for the duration until play is manually triggered.
      const hdr = chunks[0];
      let mimeType = 'audio/mpeg';
      if (hdr?.length >= 4) {
        if (hdr[0] === 0x1A && hdr[1] === 0x45 && hdr[2] === 0xDF && hdr[3] === 0xA3) {
          mimeType = 'audio/webm';
        } else if (hdr[0] === 0x4F && hdr[1] === 0x67 && hdr[2] === 0x67) {
          mimeType = 'audio/ogg';
        }
      }
      const blob = new Blob(chunks, { type: mimeType });
      let audiurl = URL.createObjectURL(blob);
      data.selected_object.g_path = audiurl;
      setPlayerPath(audiurl);

    } catch (error) {
      console.log(`[AudioPlayer] streamResponseToPlayer: ${error}`);
    }
  }

  async function requestAudioFile(greetingsInfo) {
    console.log(greetingsInfo);
    if (greetingsInfo && greetingsInfo.greeting_mode === 1) {
      if (greetingsInfo.uploadType === 3) {
        setshowLoader(true);
        let response = await getAudioFileForTTS(greetingsInfo.id,
          greetingsInfo.greeting_type,
          greetingsInfo.greeting_id,
          greetingsInfo.fileName);
        if (response?.status === 200) {
          await streamResponseToPlayer(response, (chunks) => {
            data.selected_object.g_wav_file = (new Blob(chunks, { type: "audio/mpeg" }));
          });
        }
        setshowLoader(false);

        // if (response?.status === 200) {
        //   const blobfile = await response.blob();
        //   let audioURl = URL.createObjectURL(blobfile);
        //   data.info.audioURl = audioURl;
        //   console.log(audioURl);
        //   data.selected_object.g_path = audioURl;
        //   data.selected_object.g_wav_file = blobfile;
        //   setPlayerPath(audioURl);

        // } 
      } else {
        setshowLoader(true);
        let response =
          (await getAudioFileNew(
            greetingsInfo.id,
            greetingsInfo.greeting_type,
            greetingsInfo.greeting_id,
            greetingsInfo.fileName
          ));
        if (response?.status === 200) {
          await streamResponseToPlayer(response);
        }
        setshowLoader(false);
        // data.info.audioURl = audioURl;
        // console.log(audioURl);
        // data.selected_object.g_path = audioURl;
        // setPlayerPath(audioURl);
        // data.greetinfo = null;
      }
    } else {
      setPlayerPath("");
    }
  }

  const openGreeting = (e, code) => {
    e.stopPropagation();
    e.preventDefault();
    data.actionExecutor({
      action: 1,
      value: "greeting",
    });
  };

  const processClick = (value) => {
    if (value === " Create New") {
      data.actionExecutor({ action: 1 });
    } else {
      console.log(value);
      let tGrp = aagroups.filter(
        (grp) => grp.title === value.split(" : ")[1]
      )[0];
      console.log(tGrp);
      data.selected_object_old = data.selected_object
        ? data.selected_object
        : { ...tGrp, label: tGrp.title };
      data.selected_object = { ...tGrp, label: tGrp.title };
      data.operator_data = { ...data.operator_data };
      data.directory_data = { ...data.directory_data }
      fetchAAGroupData(tGrp);
      /***
       * getting Announcement Info
       */
      data.actionExecutor({ action: 16, value: tGrp });
    }
  };
  return (
    <>
      <div>
        <div className="huntNodeHeader">
          {data.label}
          <MDBIcon
            fas
            icon="times"
            className="cursor-pointer"
            color="light"
            onClick={() => onDelete(data.id)}
          />
        </div>
        <div className="nodeBody">
          <DropDown
            data={aagroups}
            nodedata={data}
            onLinkClick={openLocation}
            onSelect={processClick}
            disp={(item) => {
              const categoryPart = item.category ? ` : ${item.category}` : "";
              const extensionpart = item.extensions
                ? ` ${item.extensions} :`
                : "";
              return `${extensionpart} ${item.title}${categoryPart}`;
            }}
            title={
              data.selected_object ? data.selected_object.label : "Choose AA"
            }
            showhyperlink={!!data.selected_object}
          ></DropDown>

          {data.selected_object &&
            data.selected_object.title !== "Create New" && (
              <>
                <div>
                  <strong>Greeting</strong>
                </div>
                <div className="nodeAudioControls">
                  <>
                    <audio
                      src={data.selected_object.g_path + ""}
                      controls
                      controlsList="nodownload"
                      className="audio-controls"
                    ></audio>
                  </>
                </div>
                <div className={`d-flex align-items-center justify-content-between ps-0 px-2${showLoader ? " disable-routing" : ""}`}>
                  <div className="d-flex align-items-center flex-grow-1 min-w-0 me-2">
                    {showLoader && (
                      <div className="mini-spinner" ref={basicRef} style={{ zIndex: "1029" }}>
                        <MDBLoadingManagement parentRef={basicRef} />
                      </div>
                    )}
                    <small className="text-ellipsis d-block"
                      style={{
                        maxWidth: "150px"
                      }}
                    >
                      {data.info &&
                        data.info.pre_announce &&
                        data.info.pre_announce.greeting_mode + "" == "1"
                        ? data.info.pre_announce.display
                          ? data.info.pre_announce.display
                          : "Personalized"
                        : "Default"}
                    </small>
                  </div>
                  <small className="text-primary edit">
                    <a
                      href="#"
                      onClick={(e) => openGreeting(e)}
                      className="text-small"
                    >
                      Edit
                    </a>
                  </small>
                </div>
                <button className="btn-primary nodeButton" onClick={addOptions}>
                  <MDBIcon fas icon="plus" color="white" className="me-1" />
                  Add Option
                </button>
              </>
            )}
        </div>
        <Handle type="target" position="left" id="target"></Handle>
        {data.handles &&
          data.handles.map((handle, index) => (
            <>
              <Handle
                type="source"
                position="right"
                id={handle.id + ""}
                style={{
                  top: 25 * index + 210 + 30,
                  right: -1,
                  background: "#fff",
                  height: 10,
                  width: 10,
                  border: "2px solid #288cd4",
                }}
                isConnectable={true}
              >
                {(handle.id + "" == "minus1" || handle.id == "-1") && (
                  <>
                    {" "}
                    <div className="handletext">Timeout</div>
                  </>
                )}
                {handle.id + "" != "minus1" && handle.id + "" != "-1" && (
                  <>
                    <div className="handletextSelect ">
                      <div>
                        <select
                          className="handleselect nodeLinkIcon"
                          id={`options_${handle.id}`}
                          value={handle.label}
                          onChange={(e) =>
                            handleChange(e, handle.id, handle.list)
                          }
                        >
                          {optionsArray.map((item) => {
                            const isSelectedElsewhere = data.handles.some(
                              (h) => h.id !== handle.id && h.label === item
                            );
                            return (
                              <option
                                key={item}
                                value={item}
                                disabled={isSelectedElsewhere}
                              >
                                {item}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="ms-3">
                        <button
                          className="cfAAbtn"
                          onClick={(e) => {
                            delteHandle(handle.id);
                          }}
                          disabled={data.handles.length <= 2}

                        >
                          <MDBIcon fas icon="times" />
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </Handle>
            </>
          ))}
      </div>
      <></>

      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
    </>
  );
});
